import { useState, useEffect } from 'react';
import { TCredentialingDepositItem, TGetCredentialingDepositListParams } from 'types/financials';
import { getCredentialingDepositList, getPracticeCredentialingDepositList } from 'api/financials';

const useCredentialingDepositList = (
    param?: Partial<TGetCredentialingDepositListParams>,
    isPractice = false,
): [
    TCredentialingDepositItem[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetCredentialingDepositListParams>) => void,
] => {
    const [data, setData] = useState<TCredentialingDepositItem[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetCredentialingDepositListParams> = {}) => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticeCredentialingDepositList : getCredentialingDepositList;
            const res = await request({
                current: 1,
                size: 10,
                ...para,
            });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Credentialing deposit list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default useCredentialingDepositList;
